export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/javascript.4533c91.svg";